import { render, staticRenderFns } from "./ContactoBce.vue?vue&type=template&id=27de6dd2"
import script from "./ContactoBce.vue?vue&type=script&lang=js"
export * from "./ContactoBce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports